module.exports = __webpack_public_path__ + "img/depmap_svg_V178.8dde9d6a.svg";